export const environment = {
  env: 'alpha',
  production: false,
  api_url: 'https://alpha.api.kiitoskauppa.knupu.dev',
};
